export default __webpack_public_path__ + "static/raven-4-c-9f577ba05c1cdb3507fee4b83b86b7ae.webp";